module.exports = __webpack_public_path__ + "static/media/foh-pink.1310bd67.jpg";